export enum AppointmentTypeTypes {
  GET_ALL = '@appointmentType/GET_ALL',
  GET_ALL_SUCCESS = '@appointmentType/GET_ALL_SUCCESS',
  GET_ALL_FAILED = '@appointmentType/GET_ALL_FAILED',
}
